import useRouteQuery from "hooks/use-route-query";
import {COLORS} from "utils/constants";
import React from "react";
import {Column} from "layouts/index";

const SubscriptionPayment = () => {
    const query = useRouteQuery();
    const userId = query.get("userId");

    const hostname = window.location.origin;
    const webPath = `${hostname}/contractor/dashboard/directory/`
    const mobilePath = `buildhub://contractor/dashboard/directory/`

    return (
        <Column style={{
            alignItems: 'center'
        }}>
            <Column style={{
                marginTop: '10vh',
                width: 'min(100%, 500px)',
                padding: '1.4rem',
                alignItems: 'center',
                justifyContent:'center'
            }}>
                <p style={{
                    color: COLORS.colorWhite,
                    fontSize:'24px',
                    fontWeight:'bold',
                }}>Subscription Redirect</p>
                <button
                    onClick={() => {
                        const now = new Date().valueOf();
                        setTimeout(function () {
                            if (new Date().valueOf() - now > 100) return;
                            window.location.href = webPath;
                        }, 25);
                        window.location.href = mobilePath
                    }}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px',
                        alignSelf: 'center',
                        marginTop: '2rem',
                        color: COLORS.colorWhite
                    }} className={"flat-button"}>Back to BuildHub
                </button>
            </Column>
        </Column>
    )
}

export default SubscriptionPayment;